<template>
  <b-container fluid>
    <b-row>
      <b-col class="d-flex">
        <backlink class="mt-20" />
        <div class="flex-grow-1">
          <h1>
            Demande de transfert
            <div v-if="!isBusy" class="subtitle">#{{ values.transfer_number }}</div>
          </h1>
        </div>
        <div v-if="values.id" class="text-right">
          <b-button variant="outline-primary ml-10" size="lg" @click="openFormModal(values.id)">
            Modifier la fiche
            <i class="far fa-pencil ml-10"></i>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <div v-if="isBusy" class="loader"></div>
    <p v-if="isBusy" class="text-center">Les données sont en cours de chargement...</p>
    <b-row v-else>
      <b-col>
        <div class="ibox">
          <div class="ibox-content divided">
            <b-row>
              <b-col>
                <div class="underbox">
                  <i class="icone far fa-calendar-alt fa-lg"></i>
                  <dl>
                    <dt>{{ labels.axiloc_creation_date }} :</dt>
                    <dd>{{ values.axiloc_creation_date || "-" }}</dd>
                  </dl>
                </div>
                <dl>
                  <dt>{{ labels.agency }} :</dt>
                  <dd>{{ values.agency || "-" }}</dd>
                  <dt>{{ labels.old_business }} :</dt>
                  <dd>{{ values.old_business || "-" }}</dd>
                  <dt>{{ labels.new_agency }} :</dt>
                  <dd>{{ values.new_agency || "-" }}</dd>
                  <dt>{{ labels.new_business }} :</dt>
                  <dd>{{ values.new_business || "-" }}</dd>
                  <dt>{{ labels.employee }} :</dt>
                  <dd>{{ values.employee || "-" }}</dd>
                  <template v-if="values.user">
                    <dt>{{ labels.user }} :</dt>
                    <dd>{{ values.user }}</dd>
                  </template>
                  <dt>{{ labels.asker_email }} :</dt>
                  <dd>
                    <a v-if="values.asker_email" :href="'mailto:' + values.asker_email">{{
                      values.asker_email
                    }}</a>
                    <template v-else>-</template>
                  </dd>
                  <dt>{{ labels.asker_number }} :</dt>
                  <dd>{{ values.asker_number || "-" }}</dd>
                  <dt>{{ labels.comment }} :</dt>
                  <dd class="nl2br">{{ values.comment || "-" }}</dd>
                </dl>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="values.unique_references && values.unique_references.length">
      <b-col>
        <div class="ibox">
          <div class="ibox-title">Références uniques</div>
          <div class="ibox-content">
            <div class="table-wrapper">
              <b-table hover :fields="transfer_reference_fields" :items="values.unique_references">
                <template slot="product" slot-scope="data">
                  <router-link v-if="data.item.product"
                    :to="{ name: 'ProductDetail', params: { id: data.item.product.id } }">{{
                      data.item.product.name
                    }}</router-link>
                </template>
                <template slot="internal_code" slot-scope="data">
                  <router-link :to="{ name: 'ReferenceDetail', params: { id: data.item.id } }">{{
                    data.item.internal_code
                  }}</router-link>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <AdminModalForm v-if="config.useNewModal || config.useEditModal" :config="config" :id_to_edit="id_to_edit" />
  </b-container>
</template>

<script>
import config from "./config";
import reference_config from "@/components/Reference/config";
import AdminModalForm from "@/components/Global/AdminModalForm";

export default {
  name: "TransferDetail",
  components: {
    AdminModalForm,
  },
  data() {
    return {
      config: config,
      reference_config: reference_config,
      fields: {},
      labels: {},
      isBusy: false,
      transfer_reference_fields: [],
      id_to_edit: null,
    };
  },
  computed: {
    rawValues: function () {
      let rawValues = this.$store.getters[config.storeNamespace + "/getItem"](this.$route.params.id) || {};
      rawValues = _.cloneDeep(rawValues)
      if (rawValues.unique_references) {
        rawValues.unique_references.sort((a, b) => a.internal_code.localeCompare(b.internal_code))
      }
      return rawValues
    },
    values: function () {
      return this.$root.formatData(
        this.rawValues,
        this.config.fields.filter((field) => field.inDetail == true)
      );
    },
  },
  mounted() {
    // Chargement des champs à afficher dans le détail depuis la config
    // Et récupération des libellés
    this.fields = config.fields.filter((field) => field.inDetail == true);
    config.fields
      .filter((field) => field.inDetail == true)
      .forEach((field) => {
        this.labels[field.name] = field.label;
      });

    this.isBusy = true;
    this.$store
      .dispatch(config.storeNamespace + "/getItem", {
        id: this.$route.params.id,
      })
      .then(() => {
        // Test si le contenu demandé est bien trouvé
        let self = this;
        if (Object.entries(this.rawValues).length <= 0) {
          this.$toastr.error(
            "La fiche demandée n'a pas été trouvée. Assure-vous que l'URL saisie soit correcte."
          );
          setTimeout(function () {
            self.$router.go(-1);
          }, 5000);
          return;
        }
        this.isBusy = false;
      });

    // Préparation des champs pour la liste des références
    this.transfer_reference_fields = reference_config.fields
      .filter((field) => ["product", "internal_code"].includes(field.name))
      .map((field) => ({
        key: field.name,
        label: field.label,
      }));
  },
  methods: {
    openFormModal(id) {
      this.id_to_edit = id;
      this.$root.$emit("bv::show::modal", "admin_modal_form");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Transfer/TransferDetail.vue